import { error } from '@sveltejs/kit';

import { buildFilterPagePath, extendBreadcrumbsWithSlug } from '@shared/ui/breadcrumbs';

import { artworksPageApi, artworksPageLibs } from '@pages/artworks';

import type { PageLoad } from './$types';

export const load: PageLoad = async ({ fetch, data }) => {
  const {
    loadMore,
    order,
    sort,
    page,
    parsedParams,
    filters,
    configurationsId,
    configurationsType,
    configurationsName,
    associatedEntityName,
  } = data;

  const { artworks, totalCount } = await artworksPageApi.readData({
    fetch,
    page,
    loadMore,
    institutionId: Number(configurationsId),
    sort,
    order,
    ...parsedParams,
  });

  if (artworks.length === 0) {
    throw error(404, 'Page not found');
  }

  const extraPath = buildFilterPagePath({ baseUrl: '/artworks/', filters, page });

  const baseBreadcrumbs = [
    {
      name: 'Home',
      slug: '/',
      canonical: false,
    },
    {
      name: 'Artworks',
      slug: '/artworks/',
      canonical: !extraPath,
    },
  ];

  const breadcrumbs = extendBreadcrumbsWithSlug({
    baseBreadcrumbs,
    slug: extraPath,
    name: 'Artworks filters options',
  });

  const seoData = new artworksPageLibs.Seo(
    configurationsType,
    {
      galleryName: configurationsName,
      entityName: associatedEntityName,
      page,
    },
    {
      breadcrumbs,
      robots: !filters,
    },
  );

  const seo = seoData.generateSeoConfig();

  return {
    artworks,
    totalCount,
    page,
    loadMore,
    seo,
  };
};
